import { defineFcm } from '../shared/factory';

export const FCM_GROWTHBOOK_ENABLED = defineFcm('growthbook_enabled')
	.asBoolean()
	.withDefault(true)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Experiments (GrowthBook)',
		description: `Global integration-health switch for GrowthBook-backed experiments.

	When false, the middle-end forces every \`type: 'growthbook'\` experiment to its control variation
	(and typed fallback config), with no per-experiment change or deploy. Defaults to true.

	This is an escape hatch for when the GrowthBook SDK itself destabilizes pods — NOT a clean way to
	pause a single experiment. To pause one experiment with correct bucketing/exposure semantics, stop
	it in the GrowthBook dashboard instead. Exposure is deliberately not suppressed while this is off;
	exclude the disabled window in analysis instead.`,
		import: false,
	});
